<div class="editor-container">
  <rez-code-editor [language]="mode"
    [text]="data.code || placeholder"
    (textChange)="onTextChange($event)"
    *ngIf="data"
    (error)="collectErrors([$event])"></rez-code-editor>
</div>
